import AppConfig from "util/AppConfig";
import { archiveRetentionChanged, archiveRetentionShortenedBy } from "./archiveRetention";
import useIndexSetArchiveSettings from "./useIndexSetArchiveSettings";
const TITLE = "Shorten archive retention?";
const UNKNOWN_TITLE = "Change archive retention?";
const unknownMessage = (reason) => `The global archive retention time ${reason}, so it is not clear whether archives for this index set will be stored for less time after this change. Any archives deleted on the next run cannot be recovered.`;
const shortenedMessage = (from, to) => {
  const before = from === null ? "Archives for this index set are currently stored indefinitely." : `Archives for this index set are currently stored for ${from} days.`;
  return `${before} Upon this change, archives for this index set will only be stored for ${to} days. Any existing archives older than ${to} days will be deleted and cannot be recovered.`;
};
const useIndexSetSubmitConfirmation = ({ enabled = true } = {}) => {
  const applies = enabled && !AppConfig.isCloud();
  const { globalRetentionTime, isLoading } = useIndexSetArchiveSettings({ enabled: applies });
  return (initialValues, values) => {
    if (!applies) {
      return null;
    }
    if (globalRetentionTime === void 0) {
      if (!archiveRetentionChanged(initialValues, values)) {
        return null;
      }
      return {
        title: UNKNOWN_TITLE,
        message: unknownMessage(isLoading ? "is still being loaded" : "could not be loaded")
      };
    }
    const shortened = archiveRetentionShortenedBy(initialValues, values, globalRetentionTime);
    if (!shortened) {
      return null;
    }
    return { title: TITLE, message: shortenedMessage(shortened.from, shortened.to) };
  };
};
export default useIndexSetSubmitConfirmation;
